import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { CommonProductDetailsComponentBase } from '../../CommonProductDetailsComponentBase';
import { ProductLongDescriptionViewComponent } from './views';

@Component({
  selector: 'ideal-product-long-description',
  imports: [ProductLongDescriptionViewComponent],
  standalone: true,
  templateUrl: './product-long-description.component.html',
  styleUrl: './product-long-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductLongDescriptionComponent extends CommonProductDetailsComponentBase {
  protected readonly description = computed(() => this.productDetails()?.longDescription ?? '');
}
